/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BriefResponse,
  BriefRunId,
  BriefRunState,
  LaunchBriefTestRequest,
  LaunchBriefTestResponse,
  MapString,
  PaginatedResultBriefResponse,
  UpsertBriefRequest,
  UsageBulkRequestRes,
  UsageRequestRes,
  WrappedLeaseRes,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "meeting-prep";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * No description
   *
   * @tags brief
   * @name ListMeetingTypeBriefsForWorkspace
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/briefs
   * @secure
   */
  listMeetingTypeBriefsForWorkspace = (
    tenantId: string,
    workspaceId: string,
    query: {
      /**
       * @format int64
       * @min 0
       */
      page: number;
      /**
       * @format int64
       * @exclusiveMin 0
       */
      pageSize: number;
      /** @minLength 1 */
      name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultBriefResponse,
      | BriefRunId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/briefs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listMeetingTypeBriefsForWorkspace */
  listMeetingTypeBriefsForWorkspacePathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /**
       * @format int64
       * @min 0
       */
      page: number;
      /**
       * @format int64
       * @exclusiveMin 0
       */
      pageSize: number;
      /** @minLength 1 */
      name?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/briefs`, query);

  /**
   * No description
   *
   * @tags brief
   * @name UpsertMeetingTypeBrief
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/briefs
   * @secure
   */
  upsertMeetingTypeBrief = (
    tenantId: string,
    workspaceId: string,
    data: UpsertBriefRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      BriefResponse,
      | BriefRunId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/briefs`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for upsertMeetingTypeBrief */
  upsertMeetingTypeBriefPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/briefs`);

  /**
   * No description
   *
   * @tags brief
   * @name GetMeetingTypeBriefById
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/brief/{briefId}
   * @secure
   */
  getMeetingTypeBriefById = (tenantId: string, workspaceId: string, briefId: string, params: RequestParams = {}) =>
    this.request<
      BriefResponse,
      | BriefRunId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/brief/${briefId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getMeetingTypeBriefById */
  getMeetingTypeBriefByIdPathGetter = (tenantId: string, workspaceId: string, briefId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/brief/${briefId}`);

  /**
   * No description
   *
   * @tags brief
   * @name DeleteMeetingTypeBrief
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/brief/{briefId}
   * @secure
   */
  deleteMeetingTypeBrief = (tenantId: string, workspaceId: string, briefId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | BriefRunId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/brief/${briefId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteMeetingTypeBrief */
  deleteMeetingTypeBriefPathGetter = (tenantId: string, workspaceId: string, briefId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/brief/${briefId}`);

  /**
   * No description
   *
   * @tags brief
   * @name GetBriefTestResultsEndpoint
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/brief-test
   * @secure
   */
  getBriefTestResultsEndpoint = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @format uuid */
      runId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      BriefRunState,
      | BriefRunId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/brief-test`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getBriefTestResultsEndpoint */
  getBriefTestResultsEndpointPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @format uuid */
      runId: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/brief-test`, query);

  /**
   * No description
   *
   * @tags brief
   * @name TestBriefEndpoint
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/brief-test
   * @secure
   */
  testBriefEndpoint = (
    tenantId: string,
    workspaceId: string,
    data: LaunchBriefTestRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      LaunchBriefTestResponse,
      | BriefRunId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/brief-test`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for testBriefEndpoint */
  testBriefEndpointPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/brief-test`);

  /**
   * @description added as a alternative to the usages endpoint with GET method as not every http library support it
   *
   * @tags Lease
   * @name ListResourcesWhichUseThisResourceMethodPut
   * @request PUT:/v1/tenant/{tenantId}/lease
   * @secure
   */
  listResourcesWhichUseThisResourceMethodPut = (tenantId: string, data: UsageRequestRes, params: RequestParams = {}) =>
    this.request<
      WrappedLeaseRes[],
      | BriefRunId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/lease`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listResourcesWhichUseThisResourceMethodPut */
  listResourcesWhichUseThisResourceMethodPutPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/lease`);

  /**
   * @description bulk PUT usages endpoint (GET method with body is not widely supported)
   *
   * @tags Lease
   * @name ListResourcesWhichUseQueriedResourcesMethodPut
   * @request PUT:/v1/tenant/{tenantId}/lease-by-ids
   * @secure
   */
  listResourcesWhichUseQueriedResourcesMethodPut = (
    tenantId: string,
    data: UsageBulkRequestRes,
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedLeaseRes[],
      | BriefRunId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/lease-by-ids`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listResourcesWhichUseQueriedResourcesMethodPut */
  listResourcesWhichUseQueriedResourcesMethodPutPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/lease-by-ids`);
}
